import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/building/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/building/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/building/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconBuilding24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Apartment building`, id: 'icon.title.building', comment: 'Title for building icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-building-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 23V1h18v22"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 23v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4M1 23h22M7 5h3M7 9h10m-3 4h3M7 13h3m4-8h3"></path></svg>`; }
}
if (!customElements.get('w-icon-building-24')) {
  customElements.define('w-icon-building-24', IconBuilding24);
}